<ng-container [ngSwitch]="productType">
  <app-calculate-page-orv *ngSwitchCase="'orv'"></app-calculate-page-orv>
  <app-calculate-page-gg *ngSwitchCase="'gg'"></app-calculate-page-gg>
</ng-container>
